import React, { Fragment } from 'react';

import ForwarderModel from '../../../../../models/ForwarderAwb';
import StationsModel from '../../../../../models/Stations';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { TextField, Button, Grid, FormControl, Tooltip, OutlinedInput, Select as MUISelect } from '@material-ui/core';
import FwdCompanyDropDown from './ForwarderDropDown'
import StationDropDown from '../../../../common/StationDropDown'
import CreateForwarder from './CreateForwarder'

import style from '../manualEntryStyle.module.css';
import commonStyles from '../../../../common/common.module.css';
import { DelivererType } from '../../../../../models/DelivererType.enum';

import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Select from 'react-select';
import AirlineType from '../../../../../models/AirlineType';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: {
      height: '35px',
      fontSize:'13px',
      lineHeight: 1
    },
    input: {
      color: 'var(--primaryblue)'
    },
    blue: {
      transform: 'translate(14px, 10px) scale(1)',
      color: 'var(--primaryblue)',
      fontSize:'14px'
    },
    textField: {
      width: '100%',
      zIndex: 0,
    },
    close: {
      fontSize: '20px',
      position: 'absolute',
      top: 0,
      right: 0,
    },
    materialIcon: {
      fontSize: '18px',
      paddingRight: '5px'
    },
    infoText: {
      textAlign: 'center',
      fontSize: '10px',
      color: 'red',
      marginBottom: '20px'
    },    
    errorBlock: {
      display: 'flex',
      alignItems: 'center'
    },
    pError: {
      textAlign: 'center',
      fontSize: '10px',
      color: 'red',
      marginTop: '0px',
      marginBottom: '8px',
      width: '100%',
    },    
    prFields: {
      width: 'calc( 100% - 20px )',
      marginRight: '20px',
    },
    gridItem: {
      '&:not(:last-child)': {
        paddingRight: '20px'
      }
    },
    fwdInfo: {
      marginBottom: '15px',
    },
    selectdropdown: {
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control': {
        borderColor: 'transparent',
        borderRadius: 'var(--ip-br)',
        fontSize: '13px',
        minHeight: '30px !important',
        boxShadow: 'none',
        '&:hover': {
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator': {
        display: 'none'
      },
      '& .css-g1d714-ValueContainer': {
        padding: '0 8px' 
      },
      '& .css-1wa3eu0-placeholder': {
        lineHeight: 1,
        fontSize: '12px',
      },
    },
    '@media (max-width:960px)': {
      gridItem: {
        '&:nth-last-child(2)': {
          paddingRight: '0px'
        }
      },
    },
    '@media (max-width:520px)': {
      textField: {
        width: '100%',
        marginBottom: '10px'
      },
    },
    error:{
      fontSize: '10px',
      color: 'red'
    },
    formField: {
      marginRight: '50%'
    }
  });

interface ForwarderComponentProps {
  classes: any;
  forwarderName: string;
  forwarders: Array<ForwarderModel>;
  forwarderValue: number | undefined;
  forwarderLocationValue: number | undefined;
  isCreateFwd: boolean;
  handleOpenCreateFwd: () => void;
  handleChange: (type: string, event: any) => void;
  handleCreateForwarder: () => void;
  forwarderError: string;
  forwarderNameError: string;
  onClick: (event: any) => void;
  delivererType: string;
  stations: Array<StationsModel>;
  stationValue: string;
  cityCodes: Array<StationsModel>;
  handleCancelCreateFwd: () => void;
  cityCodeValue: string;
  cityCodeError: string;
  openModalRecheckFwd: boolean;
  handleCloseFwdModal: () => void;
  relevantForwarders: Array<ForwarderModel>;
  selectedForwarder: string;
  selectedForwarderLocationValue: string;
  handleSelectForwarder: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddSelForwarder: () => void;
  handleAddNewFwd: () => void;
  airlines: AirlineType[];
  airlineValue?: string;
};

interface Option {
  value: string;
  label: string;
};

const forwarderComponent = (props: ForwarderComponentProps) => {

  const { classes } = props;
  const labelText: string = props.delivererType === DelivererType.FORWARDER ? 'Select Forwarder Name' : props.delivererType === DelivererType.INTERLINE ? 'Select Airline ' : 'Select RCF';
  const headerText: string = props.delivererType === DelivererType.FORWARDER ? 'Forwarder Details' : props.delivererType === DelivererType.INTERLINE ? 'Airline details': 'Truck details';
  const headerTextNwForwarder: string = 'Add new forwarder to list';
  const labelTextStation: string = 'Select Station';
  const fwdName: Array<string> = props.forwarderName.split("|");
  const cityCodeOptions: Array<Option> = props.cityCodes.map((item: StationsModel) => (
    {
      value: item.iata_code,
      label: item.iata_code
    }
  ));

  const airlineOptions = props.airlines.map((airline: AirlineType) => (
  <option value={ airline.awb_code } key={ airline.id }>{ airline.name + '-' + airline.awb_code }</option>
  ));
  
  const getCityCodeValue = (): Option => {
    const value: Array<Option> = cityCodeOptions.filter((fwd: any) => fwd.value === props.cityCodeValue);
    return value[0];
  }
  const selectCityCodeValue: any = props.cityCodeValue ? getCityCodeValue() : null;
  const cityCodeOnChange: (event: any) => void = (event) => props.handleChange('forwarderName', event);   

  const render: JSX.Element = props.delivererType === DelivererType.FORWARDER ?
    <div>
      <div className={ style.inputsfwdEditableWrapper }>
        { !props.isCreateFwd ?       
          <React.Fragment>
            <Grid container>
              <Grid item xs={12}>
                <div className={ `${ style.info } ${ classes.fwdInfo }`}><InfoIcon color="primary" className={ classes.materialIcon } />Select forwarder or create new using "+"</div>
              </Grid>
              <Grid item md={2} sm={4} xs={12} className={ style.fwdDropdownGridItem }>
                <StationDropDown
                  items={ props.stations }
                  value={ props.stationValue }
                  onChange={ (event) =>  props.handleChange('forwarderStation', event) }
                  labelText={ labelTextStation }
                  type='fwdCompany'
                  error={ props.forwarderError }
                  onClick={ props.onClick }
                  hasCreateNewCompany={ props.delivererType !== DelivererType.FORWARDER }
                />
              </Grid>
              <Grid item md={10} sm={8} xs={12} className={ style.fwdDropdownGridItem}>
                <FwdCompanyDropDown
                  openModal={ props.handleOpenCreateFwd }
                  items={ props.forwarders }
                  value={ props.forwarderLocationValue }
                  onChange={ (event) =>  props.handleChange('forwarderCompany', event) }
                  labelText={ labelText }
                  type='fwdCompany'
                  valiant={ props.forwarderName }
                  stationValue={ props.stationValue }
                  error={ props.forwarderError }
                  onClick={ props.onClick }
                  hasCreateNewCompany={ props.delivererType !== DelivererType.FORWARDER }
                />
              </Grid>
            </Grid>          
          </React.Fragment>
        : null
        }
      </div>
      <div>
        { props.isCreateFwd && props.delivererType === DelivererType.FORWARDER &&
          <p className={ classes.pError }>Before you add a new forwarding company to the list, please make sure it does not already exist</p>
        }
        { props.isCreateFwd && props.delivererType === DelivererType.FORWARDER &&
          <div className={ style.createFwdWrapper }>
            <IconButton aria-label="Close" onClick={ props.handleCancelCreateFwd } className={ classes.close }>
              <CloseIcon color='primary' fontSize='inherit'/>
            </IconButton>
            <Grid container>
              <Grid item sm={6} xs={12} className={ classes.gridItem }>
                <label className={ commonStyles.inputLabel }>Forwarding Company Name<span className={ style.asterisk }>*</span></label>
                <TextField 
                  required
                  id="forwarderName"
                  value={ props.forwarderName }
                  onChange={ cityCodeOnChange }
                  variant="outlined"
                  InputProps={{
                    classes: { input: classes.input }
                  }}
                  InputLabelProps={{
                    className: classes.blue
                  }}
                  className={ classes.textField }
                  onClick={ props.onClick }
                  error={ props.forwarderNameError !== '' }
                />
                { props.forwarderNameError !== '' &&
                  <span className={ classes.error }>{ props.forwarderNameError }</span>
                }
              </Grid>
              <Grid item md={3} sm={6} xs={12} className= { `${ classes.selectdropdown } ${ classes.gridItem }` }>
                <label className={ commonStyles.inputLabel }>IATA City Code<span className={ style.asterisk }>*</span></label>
                <Select
                  className={ classes.select }
                  options={ cityCodeOptions }
                  value={ selectCityCodeValue }
                  onChange={ (event: any) =>  props.handleChange('cityCode', event) }
                  placeholder= 'Enter IATA City Code'
                  error={ props.cityCodeError !== ''}                               
                />
                { props.cityCodeError !== '' &&
                  <span className={ classes.error }>{ props.cityCodeError }</span>
                }
              </Grid>
              <Grid item md={3} sm={12} xs={12} className= { `${ classes.gridItem } ${ style.fwdBtn }`}>
                <Tooltip title="Add forwarder to list">
                  <Button
                    className={ style.fwdsubmitBtn }
                    variant="contained"
                    color="primary"
                    onClick={ props.handleCreateForwarder }>Add Forwarder
                  </Button>
                </Tooltip>
              </Grid>
              { props.openModalRecheckFwd &&
                <CreateForwarder
                  modalOpen={ props.openModalRecheckFwd }
                  handleCloseFwdModal={ props.handleCloseFwdModal }
                  relevantForwarders={ props.relevantForwarders }
                  forwarderInput={ props.forwarderName }
                  stationInput={ selectCityCodeValue }
                  selectedForwarder={ props.selectedForwarder }
                  selectedForwarderLocationValue={ props.selectedForwarderLocationValue }
                  handleSelectForwarder={ props.handleSelectForwarder }
                  handleAddSelForwarder={ props.handleAddSelForwarder }
                  handleAddNewFwd={ props.handleAddNewFwd }
                />
              }
            </Grid>
          </div>
        }      
      </div>
    </div> :
    <div className={ style.interlineFlex }>
      <div className={ style.interlineTransfer }>{ fwdName[0].trim() }
      </div>
        { props.delivererType === DelivererType.INTERLINE && 
          <FormControl className={ props.classes.formField }>
            <label className={ commonStyles.inputLabel }> Select the airline the shipment is being transferred to </label>
            <MUISelect
              native
              id="airlineValue"
              name="airlineValue"
              onChange={ (event) => props.handleChange('airline', event) }
              value={ props.airlineValue }
              input={ <OutlinedInput labelWidth={ 0 }  /> }
            >
              <option value=''/>
              { airlineOptions}
            </MUISelect>
          </FormControl> }
    </div>
  

  return (
    <div className={ `${ commonStyles.wrapper } ${ commonStyles.positionRelative } ${ style.wrapper }` }>
      <h3 className={ `${ commonStyles.header }` } >{ !props.isCreateFwd ? headerText : headerTextNwForwarder }</h3>
      <div className={ style.inputsWrapper } >
        { render }
      </div>
    </div>
  );
};

export default withStyles(styles)(forwarderComponent);